import { render, staticRenderFns } from "./ValidaUsuarioQuestionario.vue?vue&type=template&id=1464e10c&scoped=true"
import script from "./ValidaUsuarioQuestionario.vue?vue&type=script&lang=js"
export * from "./ValidaUsuarioQuestionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1464e10c",
  null
  
)

export default component.exports